import { render, staticRenderFns } from "./_slugInject.vue?vue&type=template&id=03cb251a&"
import script from "./_slugInject.vue?vue&type=script&lang=js&"
export * from "./_slugInject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports